export default {
    Default: "По умолчанию",
    LivingRoom: "Гостиная",
    Bedroom: "Спальня",
    Bathroom: "Ванная",
    HumanStatus: "Состояние функции наличия человека",
    FallStatus0: "Состояние функции мониторинга падений",
    StayStatusFn: "Состояние функции присутствия",
    DefenseTime: "Время постановки под охрану",
    sureModifyStatus: "Вы уверены, что хотите изменить это состояние?",
    FallRadar: "Радар падений",
    SettingRange1: "Диапазон настройки 0~3",
    SettingRange2: "Диапазон настройки 60~3600",
    SettingRange3: "Диапазон настройки 150~400",
    SettingRange4: "Диапазон настройки 5~180",
    VersionAgreement: "Версия протокола",
    ManufacturerID: "Идентификатор производителя",
    ProgramVersion: "Версия программы",
    HumanPresence: "Наличие человека",
    ActivityStatus: "Состояние активности",
    FallStatus: "Состояние падения",
    StayStatus: "Состояние присутствия",
    UsageScenario: "Сценарий использования",
    StayTime: "Время присутствия",
    InstallationHeight: "Высота установки",
    FallDuration: "Длительность падения",
    FallSensitivity: "Чувствительность падения",
    NoFall: "Без падения",
    Fall: "Падение",
    NoStaticStay: "Нет статичного присутствия",
    StaticStay: "Есть статичное присутствие",
    Second: "сек",
    Minute: "мин",
    Hour: "ч",
    Axis: "Ось",
    Trend: "Тренд",
    minute5Tips: "При единице «мин» период не может быть менее 5",
    NoTrend: "Нет данных по тренду концентрации",
    ConcentTrend: "Тренд концентрации",
    Controller: "Контроллер",
    Detector: "Детектор",
    Threshold: "Настройка порогов высокой/низкой тревоги",
    HighThreshold: "Порог высокой тревоги",
    LowThreshold: "Порог низкой тревоги",
    CameraList: "Список камер",
    AddCamera: "Добавить камеру",
    ViewTrend: "Просмотр тренда концентрации",
    ViewCamera: "Просмотр камер",
    sureDelCamera: "Удалить эту камеру?",
    SensosSettings: "Настройка чувствительности вибрации",
    settingCamera: "Настройка параметров камеры",
    previous: "Предыдущее устройство",
    next: "Следующее устройство",
    ThresholdSet: "Настройка порогов",
    failCommand: "Не удалось сохранить команду",
    succCommand: "Команда сохранена, ожидание выполнения устройством",
    Gastype: "Тип газа",
    repectDate: "Повторяющаяся дата",
    UnbindDevices: "Отвязать все устройства",
    LinkedSelf: "Самопроверка связи со светозвуком",
    TurnRelay: "Включить реле управления алгоритмом",
    TurnOffRelay: "Выключить реле управления алгоритмом",
    EnableRelay: "Включить удалённое реле",
    DisableRelay: "Выключить удалённое реле",
    DefenseID: "ID зоны",
    DefenseNumber: "Номер зоны",
    DTName: "Название типа устройства",
    DN: "Тип устройства",
    DSName: "Состояние устройства",
    selfInspection: "Самопроверка зоны",
    erasure: "Отключение звука зоны",
    delarea: "Удалить зону",
    delareaTip: "Удалить зону?",
    selfInspectionTip: "Отправить самопроверку зоны?",
    earsureTip: "Отправить отключение звука зоны?",
    height_input: "Введите порог высокой тревоги",
    low_input: "Введите порог низкой тревоги",
    week256: "Период не может превышать 256",
    weekUnit: "Выберите единицу периода",
    weekNumber: "Период должен быть положительным целым",
    valvePit: "Подземный колодец клапана",
    enterSearch: "Нажмите Enter для поиска",
    Unorting: "Низкая тревога",
    Sensber: "Номер датчика",
    Measurange: "Диапазон измерений",
    Decit: "Знаков после запятой",
    Uniue: "Единица значения",
    Oveting: "Высокая тревога",
    step: "уровень",
    gasDetector: "Газовый детектор",
    batteryVoltage: "Напряжение батареи",
    signal: "Сигнал",
    GasTrends: "Тренд данных газового детектора",
    remotePhotography: "Удалённая съёмка",
    ioNumber: "Номер ввода-вывода",
    photoTimer: "Съёмка по таймеру",
    voiceAlarm: "Тревога по голосу",
    time: "Момент времени",
    selectTime: "Выбор времени",
    sensor: "Датчик",

    Preheating: "Состояние прогрева",
    Invalid: "Недействительно",
    PowerLoss: "Потеря питания",
    Failure: "Ошибка связи (контроллер не читает датчик)",
    Overrange: "Вне диапазона",
    SelfTest: "Самопроверка",
    HBSignal: "Сигнал сердцебиения",
    SOSSignal: "Сигнал SOS",
    AbSignal: "Аномальный сигнал (тревога и неисправность)",
    STELAlarm: "Тревога STEL",
    TWAAlarm: "Тревога TWA",
    highTempAlarm: "Тревога высокой температуры",
    lnglatLose: "Отсутствуют координаты, карта не загружена",
    industryCheck: "Промышленный контроль качества",

    attrCode: "Код атрибута",
    attrName: "Название атрибута",
    attrValue: "Значение атрибута",
    noAttr: "Нет данных атрибутов",
}
